import { render, staticRenderFns } from "./BrandingCase.vue?vue&type=template&id=177c7400&scoped=true&"
import script from "./BrandingCase.vue?vue&type=script&lang=js&"
export * from "./BrandingCase.vue?vue&type=script&lang=js&"
import style0 from "./BrandingCase.vue?vue&type=style&index=0&id=177c7400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c7400",
  null
  
)

export default component.exports